import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CaseConverter = () => {
  const [inputText, setInputText] = useState("");
  const [resultText, setResultText] = useState("");

  // Handlers for case conversion
  const handleUpperCase = () => setResultText(inputText.toUpperCase());
  const handleLowerCase = () => setResultText(inputText.toLowerCase());
  const handleSentenceCase = () => {
    const sentenceCased = inputText
      .toLowerCase()
      .replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
    setResultText(sentenceCased);
  };
  const handleTitleCase = () => {
    const titleCased = inputText
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    setResultText(titleCased);
  };

  // Copy result to clipboard
  const handleCopy = () => {
    if (resultText.trim() === "") {
      toast.error("Nothing to copy!", );
    } else {
      navigator.clipboard.writeText(resultText);
      toast.success("Result copied to clipboard!", );
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Case Converter</h2>

      {/* Input Section */}
      <div className="row">
        <div className="col-12">
          <textarea
            className="form-control mb-3"
            rows="5"
            placeholder="Enter text here..."
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          ></textarea>
        </div>
      </div>

      {/* Button Section */}
      <div className="row">
        <div className="col-12 col-md-3 mb-2">
          <button
            onClick={handleUpperCase}
            className="btn btn-primary w-100"
          >
            Uppercase
          </button>
        </div>
        <div className="col-12 col-md-3 mb-2">
          <button
            onClick={handleLowerCase}
            className="btn btn-primary w-100"
          >
            Lowercase
          </button>
        </div>
        <div className="col-12 col-md-3 mb-2">
          <button
            onClick={handleSentenceCase}
            className="btn btn-primary w-100"
          >
            Sentence Case
          </button>
        </div>
        <div className="col-12 col-md-3 mb-2">
          <button
            onClick={handleTitleCase}
            className="btn btn-primary w-100"
          >
            Title Case
          </button>
        </div>
      </div>

      {/* Result Section */}
      <div className="row">
        <div className="col-12">
          <div className="form-control mb-3" style={{ minHeight: "100px" }}>
            {resultText}
          </div>
        </div>
      </div>

      {/* Copy Button */}
      <div className="row">
        <div className="col-3">
          <button
            onClick={handleCopy}
            className="btn btn-success w-100"
          >
            Copy Result
          </button>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default CaseConverter;
